module.exports = __webpack_public_path__ + "static/media/nequi-logo.6325a369.svg";